module.exports = __webpack_public_path__ + "app/assets/images/man19-06d6f3e7eb1cead08af82418c75f97b1.jpg";